// 處理網址的預設方法
// const getUrlString = location.href;
// const url = new URL(getUrlString);
// console.log(url);
// console.log('noHeaderFooter', url.searchParams.get('noHeaderFooter'))
// console.log('isMobile', url.searchParams.get('isMobile'))

// 所有特效都會放在這邊
const initState = {
  // isLoading: 'false',
  isShowHeaderAccountPopover: false,
  isLoading: false,
  isShowGotoTop: true,
  isMobile: window.isMobile === undefined ? false : window.isMobile,
  // getHeaderSiteID 是某些新舊混合頁面可能是透過tag檔裡面的這個變數判斷通路，未來所有共用變數可以試著放到全站用tag檔統一管理
  seoCate: window.SEOCate || window.getHeaderSiteID,
  noHeaderFooter:
    window.noHeaderFooter === undefined ? false : window.noHeaderFooter,
  noReactHeaderFooter:
    window.noReactHeaderFooter === undefined
      ? false
      : window.noReactHeaderFooter,
  // 全站廣告
  popUpAdvData: [],
  floatAdvData: [],
  instagramData: {},
  showModal: {},
  // 紅包與需要判斷是否有設定彈出視窗，但是要在redux接過彈出視窗資料後才判斷，因為目前是判斷接popUpAdvData的資料
  // 如果以後覺得這樣太麻煩，可以看看是否要改接jsp回傳的彈出視窗變數判斷
  hasSendPopUpData: false,   
  modal: {
    visible: false,
    msg: null,
    isSuccess: true,
  },
  productTrackingNum: 0,
};

export function commonState(state = initState, action) {
  switch (action.type) {
    case 'CHANGE_EFFECT_ISLOADING': {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    case 'UPDATE_IS_SHOW_HEADER_ACCOUNT_POPOVER': {
      return {
        ...state,
        isShowHeaderAccountPopover: action.payload,
      };
    }
    case 'GET_COMMON_ADV': {
      return {
        ...state,
        popUpAdvData: action.payload.trplus_popup,
        floatAdvData: action.payload.plus_FloatAdv,
        oneByOneAds: action.payload.oneByOneAds,
        cateID: action.payload.cateID,
        hasSendPopUpData: true,
      };
    }
    case 'GET_INSTAGRAM_DATA': {
      return {
        ...state,
        instagramData: action.payload,
      };
    }
    case 'UPDATE_SHOW_MODAL': {
      const {isShow, modalName, modalContent} = action.payload;
      return {
        ...state,
        showModal: action.payload,
      };
    }
    case "SHOW_API_SUCCESS_MODAL": {
      return {
        ...state,
        modal: {
          visible: true,
          isSuccess: true,
          ...action.payload,
        },
      };
    }
    case "SHOW_API_EXCEPTION_MODAL": {
      return {
        ...state,
        modal: {
          visible: true,
          isSuccess: false,
          ...action.payload,
          msg: action.payload.msg || "系統忙碌中，請稍後再試",
        },
      };
    }
    case "CLOSE_API_MESSAGE_MODAL": {
      return {
        ...state,
        modal: { visible: false, msg: null, isSuccess: true },
      };
    }
    case "GET_PRODUCT_TRACKING_NUM": {
      return {
        ...state,
        productTrackingNum: action.payload,
      };
    }
    default:
      return state;
  }
}

export default commonState;
